<template>
    <span>
        <input type="checkbox" checked v-model="ivalue" v-on:input="click" />
        <span v-on:click="click">
            <slot></slot>
        </span>
    </span>
</template>

<script>
export default {
    props: {
        value: Boolean,
    },
    components: {
    },
    data: function () {
        return {
            ivalue: this.value
        }
    },
    methods: {
        click: function () {
            this.ivalue = !this.ivalue
            this.$emit('click', this.ivalue)
        }
    },
}
</script>

<style>
</style>